import React from 'react';

import { observer } from 'mobx-react';
import { Surface } from '@infoods/lifebase-ui';

import classes from './ScanAnalyticsWidget.module.scss';
import { WidgetTitle } from '../WidgetTitle/WidgetTitle';
import { ClientsInfoItem } from '../../../components/ClientsInfoItem/ClientsInfoItem';
import { ScanAnalyticsGraph } from './ScanAnalyticsGraph/ScanAnalyticsGraph';
import { useScanAnalyticsData } from './hooks/useScanAnalyticsData';
import { entityDashboardFilterStore } from '../../../stores/entityDashboardFilterStore';

const ScanAnalyticsWidget = observer(() => {
  const { dateRangePreset, solutionTypeFilter } = entityDashboardFilterStore;
  const { scanAnalyticsData } = useScanAnalyticsData({
    dateRangePreset,
    solutionTypeFilter,
  });

  return (
    <Surface radius="l" className={classes.container}>
      <WidgetTitle
        title="Scan Analytics"
        tooltipContent={
          <>
            Scans this period + total scans
            <br />
            Tracks usage over time
          </>
        }
      />
      {scanAnalyticsData && (
        <>
          <div className={classes.scansInfo}>
            <ClientsInfoItem
              title="Scans This Period"
              value={scanAnalyticsData.newScans.value}
              diffPercent={scanAnalyticsData.newScans.diffPercent}
              indicatorColor="info-400"
            />
            <ClientsInfoItem title="Total Scans" value={scanAnalyticsData.totalScans} />
          </div>
          <ScanAnalyticsGraph
            scanAnalyticsGraphData={scanAnalyticsData.scanAnalyticsGraph}
          />
        </>
      )}
    </Surface>
  );
});

export { ScanAnalyticsWidget };
